import * as React from 'react';
import { Accordion, LabelSlide } from '@estee/elc-accordion';
import { IWrapperComponent } from './withWrapper';
import { toMachineName } from './../../helpers/toMachineName';

export const AccordionWrapper = ({ children, title = '' }: IWrapperComponent) => {
    return (
        <Accordion>
            <LabelSlide id={toMachineName(title)} title={title}>
                {children}
            </LabelSlide>
        </Accordion>
    );
};
